<mat-card>
  <mat-card-title *ngIf='!short' fxLayout="row" fxLayoutAlign="space-between start">
    <div>
      {{ eventInfo.name }}
      <button mat-raised-button color="accent" *ngIf='showEditButton()' (click)='editEvent()'>
        <i class='fa fa-pencil'></i> Edit
      </button>
      <button mat-raised-button color="accent" *ngIf='showVerifyButton()' (click)='verifyEvent()'>
        <i class='fa fa-thumbs-up'></i> Verify
      </button>
      <button mat-raised-button color="accent" *ngIf='showResultsButton()' (click)='showResults()'>
        <i class='fa fa-trophy'></i> Results
      </button>
      <button mat-raised-button color="primary" [matMenuTriggerFor]="communicate" *ngIf='isAdmin()'>
        <i class='fa fa-envelope'></i> Communicate
        <i class='fa fa-caret-down'></i>
      </button>
    </div>
    <div *ngIf="eventList && isRoundOfMultiRound()" fxLayout="row" fxLayoutGap="5px">
      <button mat-raised-button color="accent" (click)="prevRound(eventInfo.group_event_id)"
        [disabled]="isFirstRound(eventInfo.group_event_id)">
        <i class='fa fa-chevron-left'></i> Prev Round
      </button>
      <button mat-raised-button color="accent" (click)="nextRound(eventInfo.group_event_id)"
        [disabled]="isLastRound(eventInfo.group_event_id)">
        Next Round <i class='fa fa-chevron-right'></i>
      </button>
      <button mat-raised-button color="accent" *ngIf='isAdmin()' (click)="addRoundToMultiRound()">
        New Round
      </button>
    </div>
  </mat-card-title>
  <mat-card-content fxLayout='row' fxLayoutAlign='space-between start'>
    <div fxFlex>
      <div *ngIf='masterEvent && isRoundOfMultiRound()'>
        of {{masterEvent.name}}
        <button mat-button (click)='editMasterEvent()' *ngIf='isAdmin()'>
          <i class='fa fa-pencil'></i> Edit</button>
        <button mat-button (click)='overallResults()'>
          <i class='fa fa-trophy'> Overall Results</i>
        </button>
      </div>
      <div [ngClass]='getEventClass()'>
        {{eventInfo.scoring_name}} &#64; {{eventInfo.coursename}}
        <br /> {{eventInfo.event_date.replace(' ','T') | date: 'E, MMM d y h:mm a'}}
        <br />
      </div>
      <button *ngIf='canEditEvent && !short' mat-raised-button (click)='groupSettings()'>
        <i class='fa fa-gears'></i> {{eventInfo.group_name}}
      </button>
      <div style='padding-top:10px;padding-bottom:0px' *ngIf='isResultPage() || isInfoPage()'>
        <b>SHARE THIS PAGE</b><br />
        <a href='{{getFacebookLink()}}'><img src='/assets/images/facebook-green.png' width='40px'></a>
        <a href='{{getTwitterLink()}}'><img src='/assets/images/twitter-green.png' width='40px'></a>
      </div>
      <div *ngIf='!isEventPaid()' class='warn-color'>
        <p *ngIf='isTournament()'>
          We are still missing the payment for your event, please submit it
          <button mat-raised-button (click)='submitPayment()'>here</button>
        </p>
        <p *ngIf='!isTournament() && !isTrip()'>
          The payment on your group has lapse or you created an event with more players then your subscription allows.
          You will not
          be able to access your results. Update your membership
          <a (click)='submitPayment()'>here</a>
        </p>
        <p *ngIf='isTrip()'>
          You have too many players for your subscription level.
        </p>
        <p *ngIf='error.length>0'>
          {{error}}
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-menu #communicate='matMenu' [overlapTrigger]="false">
  <button mat-menu-item (click)='sendTeeTimesEmail()'>
    Send Tee Times eMail
  </button>
  <button mat-menu-item (click)='sendResultLinkEmail()'>
    Send Result Link eMail
  </button>
  <button mat-menu-item (click)='sendNote()'>
    Send note to participants
  </button>
  <button mat-menu-item (click)='sendReminder()'>
    Send Reminder Email
  </button>
</mat-menu>